/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'intimacy': {
    width: 800,
    height: 800,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M4.46 12.84l17.775-3.778a2 2 0 011.506.28l8.098 5.259a2 2 0 001.505.279l4.08-.868a2 2 0 012.373 1.541l.624 2.934a2 2 0 01-1.54 2.373l-7.016 1.49a2 2 0 01-1.505-.278l-8.099-5.26a2 2 0 00-1.505-.279l-3.102.66M43.54 33.16l-17.775 3.778a2 2 0 01-1.505-.28l-8.1-5.259a2 2 0 00-1.504-.279l-4.08.868a2 2 0 01-2.373-1.54l-.624-2.935a2 2 0 011.54-2.372l7.016-1.491a2 2 0 011.505.279l8.099 5.259a2 2 0 001.505.279l3.102-.66" _stroke="#000" stroke-width="4" stroke-linecap="round"/>'
  }
})
